import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  TextField,
  Slider,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Tab,
  Tabs,
  Card,
  CardContent,
  IconButton,
  CircularProgress,
  Alert,
  Stack
} from '@mui/material';
import {
  PlayArrow,
  Pause,
  VolumeUp,
  Speed,
  History,
  Delete,
  Save,
  Cancel
} from '@mui/icons-material';
import ApiFetch from '../ApiFetch';
import Header from '../Header';
import Footer from '../Footer';
import ReactGA from "react-ga4";

const TextToSpeechInterface = () => {
  async function getGeneratedHistory(){
    return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/tts/getGeneratedHistory").then((r)=>r.json().then((json)=>{
        return json
    }))
  }
  const [text, setText] = useState('');
  const [volume, setVolume] = useState(100);
  const [speed, setSpeed] = useState(1);
  const [activeTab, setActiveTab] = useState(0);
  const [processingStatus, setProcessingStatus] = useState(0);
  const [errorMessage, setErrorMessage] = useState("")
  const [audioUrl, setAudioUrl] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [speaker, setSpeaker] = useState('e756b8e4-b606-4e15-99b1-3f9c6a1b2317');
  const [speakerStyle, setSpeakerStyle] = useState('888753760');
  const [speakerStyleList, setSpeakerStyleList] = useState({"e756b8e4-b606-4e15-99b1-3f9c6a1b2317":[{"speaker":"女性","style":"ノーマル","value":"888753760"},{"speaker":"女性","style":"通常","value":"888753761"},{"speaker":"女性","style":"テンション高め","value":"888753762"},
    {"speaker":"女性","style":"落ち着き","value":"888753763"},{"speaker":"女性","style":"上機嫌","value":"888753764"},{"speaker":"女性","style":"怒り・悲しみ","value":"888753765"},
  ],"754d769b-7128-4172-964e-b10945d55e39":[{"speaker":"男性","style":"ノーマル","value":"606865152"}]});
  const audioRef = useRef(null);
  const statusCheckIntervalRef = useRef(null);
  const requestIdRef = useRef(null);
  const oldRequestIdRef = useRef(null);

  const [history, setHistory] = useState([
    {
      id: 1,
      text: 'サンプルテキスト1',
      speaker: 'female1',
      date: '2024-11-21 10:30',
      duration: '0:45'
    },
    {
      id: 2,
      text: 'サンプルテキスト2',
      speaker: 'male1',
      date: '2024-11-21 11:15',
      duration: '1:30'
    }
  ]);
  function download(url, filename) {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || ''; // filenameが指定されない場合、元のファイル名を使用
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  const handleGenerateRequest = async () => {
    setErrorMessage("")
    try {
      const response = await fetch(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/tts/textToSpeech", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          text,
          speed,
          volume: volume / 100,
          speaker,
          speakerStyle
        }),
        credentials: "include"
      });
      const data = await response.json();
      if(!data.result){
        clearInterval(statusCheckIntervalRef.current);
        setErrorMessage(data.errors)
      } else {
        requestIdRef.current = data.data.procId;
        setProcessingStatus(1);
        startStatusCheck()
      }
    } catch (error) {
      console.error('音声生成リクエストエラー:', error);
      setProcessingStatus(4);
    }
  };
  function base64ToFile(base64,filename,mime){
    let bin = atob(base64.replace(/^.*,/, ''));
    let buffer = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
    }
    return new File([buffer.buffer], filename, {type: mime});
  }
  async function getAudioUrl(procId){
    const response = await fetch(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/tts/getAudio/"+procId,{credentials: "include"});
    const data = await response.json();
    if(data.result){
      let audio = base64ToFile(data.data.audio[0],procId+".wav","audio/wav")
      const url = URL.createObjectURL(audio);
      return url
    } else {
      return false
    }
  }
  const startStatusCheck = () => {
    statusCheckIntervalRef.current = setInterval(async () => {
      try {
        const response = await fetch(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/tts/statusCount",{credentials: "include"});
        const data = await response.json();
        if(!data.result){
          throw new Error();
        }
        setProcessingStatus(data.data.status);
        if(data.data.status === 0){
          if(requestIdRef.current !== null){
            clearInterval(statusCheckIntervalRef.current);
            setProcessingStatus(3)
            let procId = requestIdRef.current
            requestIdRef.current = null
            const response = await fetch(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/tts/getAudio/"+procId,{credentials: "include"});
            const data = await response.json();
            if(data.result){
              oldRequestIdRef.current = procId
              let audio = base64ToFile(data.data.audio[0],procId+".wav","audio/wav")
              const url = URL.createObjectURL(audio);
              setAudioUrl(url);
              handlePlayAudio(url);
            } else {
              setErrorMessage(data.errors)
              setProcessingStatus(-1)
            }
          }
        } else if(data.data.status === 1){
          requestIdRef.current = data.data.procId
        } else if (data.data.status === 4 || data.data.status === 5) {
          clearInterval(statusCheckIntervalRef.current);
        }
      } catch (error) {
        console.error('状態チェックエラー:', error);
        clearInterval(statusCheckIntervalRef.current);
        setProcessingStatus(4);
      }
    }, 1000);
  };

  const handleCancel = async () => {
    try {
      console.group(requestIdRef.current)
      const response = await fetch(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/tts/generateCancel", {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({procId:requestIdRef.current}),
        credentials: "include"
      });
      const data = await response.json();
      requestIdRef.current = null
      if(!data.result){
        setErrorMessage(data.errors)
      } else {
        setProcessingStatus(0);
      }
      clearInterval(statusCheckIntervalRef.current);
      
    } catch (error) {
      console.error('キャンセルリクエストエラー:', error);
    }
  };

  const handlePlayAudio = (url) => {
    if (audioRef.current) {
      audioRef.current.src = url;
      audioRef.current.play();
      setIsPlaying(true);
    }
  };

  const handlePauseAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };

  const handlePlayToggle = () => {
    if (processingStatus === 0 || processingStatus === 4) {
      handleGenerateRequest();
    } else if (processingStatus === 1 || processingStatus === 2) {
      handleCancel();
    } else if (processingStatus === 3) {
      if (isPlaying) {
        handlePauseAudio();
      } else {
        handlePlayAudio(audioUrl);
      }
    }
  };

  const handleSave = () => {
    const newHistoryItem = {
      id: history.length + 1,
      text,
      speaker,
      date: new Date().toLocaleString(),
      duration: audioRef.current ? `${Math.floor(audioRef.current.duration)}秒` : '0秒'
    };
    setHistory([newHistoryItem, ...history]);
  };

  const handleDelete = (id) => {
    setHistory(history.filter(item => item.id !== id));
  };

  useEffect(() => {
    ReactGA.initialize("G-7W9JKQ50Y6");
    ReactGA.send({
      hitType: "pageview",
      // アクセスしたパス (pathname) とクエリ文字列 (search) を送付する (必要に応じて編集する)
      page: "/generate/voice",
    })
    startStatusCheck()
    getGeneratedHistory().then(r => {
      if(r.result){
        setHistory(r.data)
      }
    })
  },[])

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.onended = () => {
        setIsPlaying(false);
      };
    }
    return () => {
      if (statusCheckIntervalRef.current) {
        clearInterval(statusCheckIntervalRef.current);
      }
      if (audioUrl) {
        URL.revokeObjectURL(audioUrl);
      }
    };
  }, [audioUrl]);

  useEffect(() => {
    setSpeakerStyle(speakerStyleList[speaker][0].value)
  },[speaker])

  const getButtonContent = () => {
    if (processingStatus === 1 || processingStatus === 2) {
      return (
        <>
          <Cancel /> キャンセル
        </>
      );
    }
    if (processingStatus === 3) {
      return isPlaying ? (
        <>
          <Pause /> 一時停止
        </>
      ) : (
        <>
          <PlayArrow /> 再生
        </>
      );
    }
    return (
      <>
        <PlayArrow /> 生成して再生
      </>
    );
  };

  return (
    <div>
      <Header />
      <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 3, mt: 3 }}>
        <Typography variant="h4" gutterBottom>
          音声読み上げ
        </Typography>

        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          sx={{ mb: 3 }}
        >
          <Tab label="テキスト入力" />
          <Tab label="履歴" icon={<History />} iconPosition="start" />
        </Tabs>

        {activeTab === 0 && (
          <Stack spacing={3}>
            <Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="subtitle1">読み上げるテキスト</Typography>
                <Button
                  className='d-none'
                  startIcon={<Save />}
                  variant="outlined"
                  size="small"
                  onClick={handleSave}
                >
                  保存
                </Button>
              </Box>
              <TextField
                fullWidth
                multiline
                rows={4}
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="ここにテキストを入力してください..."
              />
            </Box>

            <FormControl fullWidth>
              <InputLabel>話者</InputLabel>
              <Select
                value={speaker}
                onChange={(e) => setSpeaker(e.target.value)}
                label="話者"
              >
                <MenuItem value="e756b8e4-b606-4e15-99b1-3f9c6a1b2317">女性</MenuItem>
                <MenuItem value="754d769b-7128-4172-964e-b10945d55e39">男性</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth>
            <InputLabel>スタイル</InputLabel>
            <Select
                  value={speakerStyle}
                  onChange={(e) => setSpeakerStyle(e.target.value)}
                  label="スタイル"
                >
            {speakerStyleList[speaker].map((d,i) => {
              return <MenuItem key={i} value={d.value}>{d.style}</MenuItem>
            })}
            </Select>
            </FormControl>

            <Box>
              <Typography gutterBottom>
                <VolumeUp sx={{ mr: 1, verticalAlign: 'middle' }} />
                音量: {volume}
              </Typography>
              <Slider
                value={volume}
                onChange={(_, newValue) => setVolume(newValue)}
                min={0}
                max={100}
              />
            </Box>

            <Box>
              <Typography gutterBottom>
                <Speed sx={{ mr: 1, verticalAlign: 'middle' }} />
                再生速度: {speed}x
              </Typography>
              <Slider
                value={speed}
                onChange={(_, newValue) => setSpeed(newValue)}
                min={0.5}
                max={2}
                step={0.1}
              />
            </Box>

            {(processingStatus === 1 || processingStatus === 2) && (
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <CircularProgress size={20} sx={{ mr: 1 }} />
                <Typography color="primary">生成中...</Typography>
              </Box>
            )}

            {errorMessage.length > 0 && (
              <Alert severity="error">
                {errorMessage}
              </Alert>
            )}

            {processingStatus === 4 && (
              <Alert severity="error">
                処理に失敗しました。もう一度お試しください。
              </Alert>
            )}

            {null !== audioUrl ? (
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <audio src={audioUrl} controls />
              </Box>
            ) : ""}
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                className='m-1'
                variant="contained"
                onClick={handlePlayToggle}
                disabled={!text.trim() && processingStatus === 0 || processingStatus === 2}
                color={processingStatus === 1 || processingStatus === 2 ? "error" : "primary"}
              >
                {getButtonContent()}
              </Button>
              <audio ref={audioRef} onEnded={() => setProcessingStatus(0)} />
              <Button
                className='m-1'
                startIcon={<Save />}
                variant="outlined"
                size="small"
                href={audioUrl}
                download={"ourt_ai_" + oldRequestIdRef.current + ".wav"}
                disabled={null === audioUrl || processingStatus === 1}
                //onClick={() => URL.revokeObjectURL(audioUrl)}
              >
                保存
              </Button>
            </Box>
          </Stack>
        )}

        {activeTab === 1 && (
          <Stack spacing={2}>
            {history.map((item) => (
              <Card key={item.proc_id}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography variant="h6" noWrap sx={{ maxWidth: 400 }}>
                        {item.text.length > 50 ? `${item.text.substring(0, 50)}...` : item.text}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {item.date} | 話者: {item.speaker} | 再生時間: {item.duration}
                      </Typography>
                    </Box>
                    <Box>
                      <IconButton
                        onClick={() => {
                          //setText(item.text);
                          //setSpeaker(item.speaker);
                          //setActiveTab(0);
                          getAudioUrl(item.proc_id).then(r => {
                            setAudioUrl(r)
                            handlePlayAudio(r)
                            setActiveTab(0)
                          })
                        }}
                      >
                        <PlayArrow />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          getAudioUrl(item.proc_id).then(url => {
                            download(url, "ourt_ai_" + item.proc_id + ".wav")
                          })
                        }}
                      >
                        <Save />
                      </IconButton>
                      <IconButton
                        className='d-none'
                        onClick={() => handleDelete(item.proc_id)}
                        color="error"
                      >
                        <Delete />
                      </IconButton>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Stack>
        )}
      </Paper>
      </Container>
      <Footer />
    </div>
  );
};

export default TextToSpeechInterface;